module.exports = __webpack_public_path__ + "9aad2ac1eacd1149cd3d057b8f480298.svg";